import { render } from "./BookMarkButton.vue?vue&type=template&id=81fac8b2&scoped=true"
import script from "./BookMarkButton.vue?vue&type=script&lang=js"
export * from "./BookMarkButton.vue?vue&type=script&lang=js"

import "./BookMarkButton.vue?vue&type=style&index=0&id=81fac8b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81fac8b2"]])

export default __exports__